// @flow
// Duration constants
export const DURATION_SHORT = 'short';
export const DURATION_LONG = 'long';

// Type constants
export const TYPE_DEFAULT = 'default';
export const TYPE_INFO = 'info';
export const TYPE_WARN = 'warn';
export const TYPE_ERROR = 'error';

// Overflow constants
export const OVERFLOW_WRAP = 'wrap';
export const OVERFLOW_ELLIPSIS = 'ellipsis';
